import { Box } from '@factorialco/deprecated-design-system'
import { VerticalBarChart } from '@factorialco/f0-react'
import {
  FormElementAnalyticsDocument,
  FormInsightsOverviewElementFragment,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ChartWidget } from 'modules/engagement_surveys/components/FormInsightsOverview/InsightsVisualization/ChartWidget'
import type { FormFiltersStorage } from 'modules/forms'

import { LoadingState } from './LoadingState'
import { mapChartDataToOptionLabels, mergeAnalyticsData } from './utils'

interface Props {
  element: FormInsightsOverviewElementFragment
  activeFilters?: FormFiltersStorage['filters']
  materializedFormId?: string
}

export function Rating({ element, activeFilters, materializedFormId }: Props) {
  const { data, loading } = useQuery(FormElementAnalyticsDocument, {
    variables: {
      elementId: element.id,
      ...activeFilters,
      materializedFormId,
    },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  })

  if (loading) {
    return <LoadingState element={element} />
  }

  const { categories, series } = data?.forms.elementAnalyticsConnection?.nodes?.[0] || {}

  const chartData = mergeAnalyticsData({
    allOptions: element.options.map((option) => Number(option.value).toString()),
    categories: categories?.map((category) => Number(category).toString()),
    series,
  })

  const chartDataWithLabels = mapChartDataToOptionLabels(chartData, element.options)

  return (
    <ChartWidget
      title={element.label}
      description={element.description || ''}
      questionType={element.type}
    >
      <Box style={{ height: `${element.options.length * 24 + 16}px` }}>
        <VerticalBarChart
          data={chartDataWithLabels}
          dataConfig={{
            value: {
              label: 'Value',
            },
          }}
          hideGrid
        />
      </Box>
    </ChartWidget>
  )
}
